import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class TipoEquipamentoDBService extends DatabaseService {
    override classname: string = 'TipoEquipamentoDBService';
    override table = 'tipo_equipamento';

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_abreviacao", field: "abreviacao", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}
